import React from 'react';

const PrivacyPolicy = () => (
  <div style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <iframe title="Privacy Policy" src="/PrivacyPolicy.pdf" style={{ width: '100%', height: '100vh', border: 'none' }}>
      <p>
        Your browser does not support PDFs. <a href="/PrivacyPolicy.pdf">Download the PDF</a>.
      </p>
    </iframe>
  </div>
);

export default PrivacyPolicy;
